import { useGetActiveScreeningQuery } from "@js/apps/auth/api";
import { useAccountType } from "@js/apps/common/hooks";
import { useUserNeedsIdentityVerification } from "@js/apps/identity-verification";

export const useIsScreeningAvailable = () => {
  const { userNeedsIdentityVerification } = useUserNeedsIdentityVerification();
  const { isFreelancerApproved, isUserVerified } = useAccountType();

  const { data: screening, isLoading: isLoadingScreening } =
    useGetActiveScreeningQuery(undefined, {
      skip:
        userNeedsIdentityVerification ||
        isFreelancerApproved ||
        !isUserVerified,
    });

  const screeningUrl = screening?.screening_url;
  const isScreeningAvailable = !!screeningUrl;

  return {
    isScreeningAvailable,
    isScreeningRetake: !!screening?.is_retry_attempt,
    isLoading: isLoadingScreening,
    screeningUrl,
  };
};
